import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Container } from "react-bootstrap";
import { Mousewheel, Navigation, Pagination } from "swiper";
import { lazyLoadVideos } from "helpers/lazyLoadVideos";
import * as style from "./style.mod.scss";
import RichText from "components/rich-text";
import Quote from "src/assets/svgs/quote.svg";
import BlueQuote from "src/assets/svgs/blue-quote.svg";
import ChefHat from "src/assets/svgs/hat-chef.svg";
import PinkChefHat from "src/assets/svgs/hat-chef-pink.svg";
import BadgeCheck from "src/assets/svgs/badge-check.svg";
import BadgeCheckPink from "src/assets/svgs/badge-check-pink.svg";
import { StarFill } from "react-bootstrap-icons";

const settings = {
  spaceBetween: 10,
  slidesPerView: "auto",
  loop: true,
  centeredSlides: true,
  className: "collection-slider-swiper",
  pagination: { clickable: true },
  navigation: {
    enabled: true,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  modules: [Pagination, Navigation, Mousewheel],
  mousewheel: {
    enabled: true,
    forceToAxis: true,
  },
  breakpoints: {
    991: {
      spaceBetween: 30,
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
};

const QuoteWithReviews = ({ data }) => {
  const { title, quote, name, occupation, video, reviews } = data;

  useEffect(() => {
    lazyLoadVideos();
  }, []);

  const Stars = ({ score }) => {
    if (!score) return <></>;
    return Array(Math.round(score)).fill().map(() => (
      <div key={Math.random()} className={style.clipStar} style={{ display: "flex" }}><StarFill /></div>
    ));
  };

  const foodboomUrl = window.location.href.includes("foodboom");

  return (
    <>
      <div className={style.sectionBackground}>
        <Container>
          <div className={style.content}>
            <div className={style.quoteVideoContainer}>
              <div className={style.quoteContainer}>
                <RichText blocks={title} className={style.title} />
                {foodboomUrl ? <BlueQuote /> : <Quote />}


                <h4 className={style.quote}>{quote}</h4>
                <div className={style.author}>
                  {foodboomUrl ? <PinkChefHat width={25} height={25} /> : <ChefHat width={25} height={25} />}
                  <h6 className={foodboomUrl ? style.h6Pink : style.h6}>
                    {name} <span className={foodboomUrl ? style.occupationPink : style.occupation}> - {occupation}</span>
                  </h6>

                </div>
              </div>
              <div className={style.videoContainer}>
                <video
                  className={`${style.smallVideo} lazyload`}
                  type="video/mp4" autoPlay muted
                  playsInline loop>
                  <source data-src={video.url} />
                  Sorry, your browser doesnt support embedded videos.
                </video>
              </div>
            </div>
            <div className={style.reviewsContainer}>
              <Swiper {...settings}>
                {reviews.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div className={style.review}>
                        <div className={style.starWrapper}>
                          <Stars score={item.starsNumber} />
                        </div>
                        <h5 className={style.text}>{item.title}</h5>
                        <p>{item.review}</p>
                        <div className={style.user}>
                          <p className={style.text}>{item.authorName} <span className={style.textRegular}> - {item.authorOccupation}</span></p>
                          <p><span>{foodboomUrl ? <BadgeCheckPink width={15} height={15}/> : <BadgeCheck width={15} height={15} />}</span> Verified buyer</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
              </Swiper>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default QuoteWithReviews;